import {post} from "../js/Requester";

export function login(body) {
  return post('login', body, { checkAuthorization: false })
    .then(response => {
      return response.data;
    });
}
